var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { typography, spacing, borderRadius, color } from '../../constants';
import { ArrowPointLeft } from '../../icons';
var Icon = styled(ArrowPointLeft)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n  fill: currentColor;\n"], ["\n  margin-right: ", ";\n  fill: currentColor;\n"])), spacing.extraTight);
var Container = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  border-radius: ", ";\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  ", "\n\n  &:hover {\n    outline: none;\n    text-decoration: underline;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  border-radius: ", ";\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  ", "\n\n  &:hover {\n    outline: none;\n    text-decoration: underline;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n"])), color.theme.primaryColor.action.primary, borderRadius.default, typography.body);
export var Back = function (_a) {
    var text = _a.text, props = __rest(_a, ["text"]);
    return (React.createElement(Container, __assign({}, props),
        React.createElement(Icon, { small: true }),
        text));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map